import { StateUtils } from '@spartacus/core';
import { DELETE_MANAGER } from '../my-account-state';

export const DELETE_PERSONAL_MANAGER = '[My Account] Delete Manager';
export const DELETE_PERSONAL_MANAGER_SUCCESS = '[My Account] Delete Manager Success';
export const DELETE_PERSONAL_MANAGER_FAIL = '[My Account] Delete Manager Fail';

export class DeletePersonalManager extends StateUtils.EntityLoadAction {
  readonly type = DELETE_PERSONAL_MANAGER;

  constructor(public payload: string) {
    super(DELETE_MANAGER, payload);
  }
}
export class DeletePersonalManagerSuccess extends StateUtils.EntitySuccessAction {
  readonly type = DELETE_PERSONAL_MANAGER_SUCCESS;

  constructor(public personalManagerId: string) {
    super(DELETE_MANAGER, personalManagerId);
  }
}
export class DeletePersonalManagerFail extends StateUtils.EntityFailAction {
  readonly type = DELETE_PERSONAL_MANAGER_FAIL;

  constructor(
    public personalManagerId: string,
    public payload: unknown,
  ) {
    super(DELETE_MANAGER, personalManagerId, payload);
  }
}
